exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-yellow{color:#fcdb01}.is-blue{color:#47c0e7}.is-red{color:#9f232b}.active{color:#f6f8f7}.client-logos{margin-top:2rem}.logo-links{padding-left:12px;margin:6px auto 24px;justify-content:center;padding-left:0}.logo-links a{padding:10px 0;background-color:#262629;border-top:1px solid #2e2e31;border-right:1px solid #212125;border-bottom:1px solid #212125}.logo-links a:hover{border-top:1px solid #1d1d25;background:linear-gradient(180deg,#1d1d25,#18181b)}.logo-links img{display:block;width:100%;margin:auto;max-width:185px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-45c9c6d5","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ClientLogos.vue
// module id = 380
// module chunks = 0